module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/91.17740ddc.png";